module.exports = __webpack_public_path__ + "img/banner-partner-with-us.ebc2ccb2.jpg";